import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Filter, FilterOneValue } from '@docpath/linces-angular-components';
import { Table } from '@docpath/webcomponents/table';
import { Constants } from 'src/app/constants/constants';

import { StatisticsService } from '../../services/statistics.service';
import { StatisticsHttpService } from '../../services/statistics-http.service';
import { StatisticsTableService } from './statistics-table.service';

@Component({
  selector: 'app-statistics-table',
  templateUrl: './statistics-table.component.html'
})
export class StatisticsTableComponent implements OnInit {
  @Input() filters: Filter[] = [];
  @Output() selectedRow = new EventEmitter<void>();
  @Output() tableLoaded = new EventEmitter<Table>();

  table: Table;
  showLoading = false;

  @Input() dgeId: number = 0;
  numberHours?: number;
  customNumberHoursFrom?: string;
  customNumberHoursTo?: string;
  lastJobId?: number;

  constructor(
    private readonly statisticsTableService: StatisticsTableService,
    private readonly statisticsService: StatisticsService,
    private readonly statisticsHttpService: StatisticsHttpService
  ) {
    this.table = this.statisticsTableService.initTable();
    this.statisticsTableService.refreshColumns(this.table);
  }

  ngOnInit(): void {
    this.statisticsService.statisticsSelectsChanged.subscribe(statisticsFilter => {
      this.dgeId = statisticsFilter.dgeId;
      this.numberHours = statisticsFilter.numberHours;
      this.customNumberHoursFrom = statisticsFilter.customNumberHoursFrom;
      this.customNumberHoursTo = statisticsFilter.customNumberHoursTo;
      this.lastJobId = statisticsFilter.lastJobId;

      this.statisticsTableService.loadJobs(false, this.dgeId ?? Constants.DGE_ALL_VALUES, this.numberHours ?? Constants.NUMBER_OF_HOURS_24,
        this.customNumberHoursFrom ?? '', this.customNumberHoursTo ?? '', this.lastJobId ?? 0, [], 1, 25);
    });

    this.statisticsTableService.jobsLoaded.subscribe(result => {
      this.table.header = this.statisticsTableService.initTableHeader();
      this.table.body = this.statisticsTableService.initTableBody(result);
      this.statisticsTableService.refreshColumns(this.table);
    });

    this.statisticsHttpService.showLoadingTableChanged.subscribe(showLoading => {
      this.showLoading = showLoading;
    });
    this.statisticsTableService.loadJobs(true, this.dgeId ?? Constants.DGE_ALL_VALUES, this.numberHours ?? Constants.NUMBER_OF_HOURS_24, 
      this.customNumberHoursFrom ?? '', this.customNumberHoursTo ?? '', this.lastJobId ?? 0, [ {'condition': 'equal-to', 'key': 'preview', 'value' : 'No'} as FilterOneValue ], 1, 25);
    this.tableLoaded.emit(this.table);
  }

  onChangeCheck(): void {
    this.selectedRow.emit();
  }

  onChangePage(page: number): void {
    this.statisticsTableService.loadJobs(true, this.dgeId ?? Constants.DGE_ALL_VALUES, this.numberHours ?? Constants.NUMBER_OF_HOURS_24, 
      this.customNumberHoursFrom ?? '', this.customNumberHoursTo ?? '', this.lastJobId ?? 0, this.filters, page);
  }

  onChangePageSize(size: number): void {
    this.statisticsTableService.loadJobs(true, this.dgeId ?? Constants.DGE_ALL_VALUES, this.numberHours ?? Constants.NUMBER_OF_HOURS_24, 
      this.customNumberHoursFrom ?? '', this.customNumberHoursTo ?? '', this.lastJobId ?? 0, this.filters, 1, size);
  }

  getCurrentPage(): number {
    return this.statisticsTableService.getCurrentPage();
  }

  getCurrentSize(): number {
    return this.statisticsTableService.getCurrentSize();
  }

  getElements(): number {
    return this.statisticsTableService.getElements();
  }
}
